import { ofType, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Auth from '../../api/auth';
import { handleError } from '../errorHandler';

import { FETCH_USERS_STARTED, fetchUsersFulfilled } from './actions';

const fetchUsersEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_USERS_STARTED),
    mergeMap((action: { payload: unknown }) =>
      from(Auth.fetchV2Users(action.payload)).pipe(
        mergeMap((response: { data: unknown }) => of(fetchUsersFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

export default fetchUsersEpic;
